import React, { forwardRef } from 'react'
import styled from 'styled-components'

import { translate } from '~/core/translate'
import Link from './link'

const Container = styled.div`
  ${({ columns }) => columns === 1
    ? `
    display: block;
  `
    : `
    column-gap: 20px;
    display: grid;
    grid-template-columns: 50% 50%;
    width: calc(100% - 20px);
  `}
`

const LinksList = forwardRef(({ columns = 1, disabled, links, linkClickedCallback }, ref) => (
  <Container
    tabIndex={-1}
    role='list'
    aria-label={translate('shared_links')}
    columns={columns}
    ref={ref}
  >
    {links.map((data, index) => (
      <div key={`${data.fileName}_${index}`} role='listitem'>
        <Link disabled={disabled} {...data} linkClickedCallback={linkClickedCallback} />
      </div>
    ))}
  </Container>
))

export default LinksList
